import { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import { BettingInformation } from '../../../Model/BettingInformation'
import { ICheckBoxPipelineProcessor } from './ICheckBoxPipelineProcessor'
import { CheckBoxPipelineProcessor } from './CheckBoxPipelineProcessor'
import { CheckBoxSelection } from '../UIElements/CheckboxSelection'
import { ISelectionContext } from './ISelectionContext'
import Guard from '../../../../AppUtils/Framework/Guard'

export default class LegInCheckBoxPipelineProcessor extends CheckBoxPipelineProcessor {
  constructor(next: ICheckBoxPipelineProcessor | null) {
    super(next)
  }

  process(
    current: IObservableStarter,
    all: ko.ObservableArray<IObservableStarter>,
    context: BettingInformation,
    selectionContext: ISelectionContext,
    count: number
  ): Array<IObservableStarter> {
    if (!context.isLegIn())
      return (this.next as ICheckBoxPipelineProcessor).process(
        current,
        all,
        context,
        selectionContext,
        count
      )

    Guard.notNull(current)
    Guard.notNull(all)
    Guard.notNull(context)

    const supplied = current.selection() as CheckBoxSelection
    const results: IObservableStarter[] = []

    if (this.isLegIn(current) && this.totalLegIns(all(), current) + 1 >= 2) {
      // Only one LegIn
      this.turnOffOtherLegIn(all, current)
      this.maintainExistingSetOfStartersWithCurrent(current, all, results)
      context.turnOffLegInField()
    } else if (
      this.isLegIn(current) &&
      !this.isWith(current) &&
      this.totalLegIns(all(), current) + 1 < 2
    ) {
      // Only one LegIn
      this.maintainExistingSetOfStartersWithCurrent(current, all, results)
    } else if (!this.isLegIn(current) && this.isWith(current)) {
      this.maintainExistingSetOfStartersWithCurrent(current, all, results)
    } else if (!this.isLegIn(current) && !this.isWith(current)) {
      supplied.clearAll()
      this.maintainExistingSetOfStartersWithCurrent(current, all, results)
      context.turnOffLegInField()
    }

    return results
  }

  private turnOffOtherLegIn(
    all: ko.ObservableArray<IObservableStarter>,
    current: IObservableStarter
  ) {
    all()
      .filter(
        starter =>
          starter.number() !== current.number() &&
          !starter.isScratched() &&
          !starter.isScratchedToteAndFob()
      )
      .filter(starter => (starter.selection() as CheckBoxSelection).selectedAt(0))
      .forEach(starter => {
        ;(starter.selection() as CheckBoxSelection).clearAll()
      })
  }
}
